import * as $ from 'jquery';

export default function initTabs() {
	// Listing Summary expand and collapse

	// AE requested that this functionality be removed as part of the 2018 enhancements
	/* var $summ = $('.listingSummary');

	$summ.each(function(){

		var $this = $(this),
			th = $this.height(),
			$tp = $this.parent(),
			$more = $tp.find('a.more-less');

		$more.attr('data-height', th)

		if  ( th > 100 ) {
			$this.css({
				'max-height' : '100px'
			});
			$more.css({'display' : 'inline-block'});
			$this.append('<div class="fade"></div>');

			if ($tp.parent().hasClass('odd')) {
				$tp.find('.fade').addClass('whiteFade');
			}
		}

		var isOpen = false;

		$more.click(function(ev){
			ev.preventDefault();
			ev.stopPropagation();

			var newHeight = $(this).data('height'),
				$tpp = $(this).parent().parent();

			if (!isOpen) {
				$this.css('max-height', '');

				$(this).text('Show Less');
				$this.css({
					'top' : '0',
					'background-position-y' : '-20px'
				});

				$tp.find('.fade').fadeOut('fast');
				$tpp.animate({'padding-bottom' : '10px'})
				isOpen = true;
			} else {
				$tp.find('.fade').fadeIn('fast');
				$(this).text('Show More');

				$this.css({
					'max-height' : '100px',
					'top' : '-15px',
					'background-position-y' : '0px'
				});

				isOpen = false;
			}

			return false;

		})

	}) */

	// Tabs
	var $tabs = $('.tabNav'),
		$tabLink = $tabs.find('a');

	$('.tabContent').css('display', 'none');
	$('.tabContent.active').css('display', 'block');
	$tabs.css({ 'display': 'flex' });

	$('h2.startHead').css({ 'display': 'none' });

	$tabLink.click(function () {
		var $this = $(this),
			id = $this.data('tab');

		if (!$this.hasClass('active')) {
			$tabs.find('a.active').removeClass('active');
			$this.addClass('active');
			$('.tabContent.active').removeClass('active').fadeOut('fast');
			$('#tab-content-' + id).fadeIn('fast', function () {
				$(this).addClass('active')
			});
		}

		return false
	});
}